import { getElements } from "core-integration/src/store/elements/reducers";
import { getTeamsById } from "core-integration/src/store/teams/reducers";
import orderBy from "lodash/orderBy";
import { Column, Table } from "plos/src/components/Table";
import TransferredOutIcon from "plos/src/img/icons/transfer-arrow-left.svg?react";
import TransferredInIcon from "plos/src/img/icons/transfer-arrow-right.svg?react";
import { fixedTable } from "plos/src/styles/utils.css";
import { TableBody, TableHeader } from "react-aria-components";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useTrackingContext } from "../../../contexts/TrackingContext";
import { StatusPanel } from "../StatusPanel";
import {
  elementColumnStyles,
  elementDialogColumnStyles,
  styledTransferArrowIcon,
  transferIconColumnStyles,
  transferredColumnStyles,
} from "./transfersTable.css";
import TransfersTableRow from "./TransfersTableRow";
import { TransferTableProps } from "./types";

const TransfersTable = ({ isOut }: TransferTableProps) => {
  const { t } = useTranslation("status");
  const { fireClickTrackEvent } = useTrackingContext();

  const handleTrackViewAllTopTransfers = () => {
    fireClickTrackEvent({
      event_component: "button click",
      event_category: "fantasy top transfers",
      event_detail: isOut
        ? "View All Top Transfers Out"
        : "View All Top Transfers In",
    });
  };

  const elements = useSelector(getElements);
  const teamsById = useSelector(getTeamsById);
  const stat = isOut ? "transfers_out_event" : "transfers_in_event";
  const sortedElements = orderBy(elements, [stat], ["desc"]).slice(0, 5);

  return (
    <StatusPanel
      title={
        isOut
          ? t("statusPanelTitleOut", "Top Transfers out this Gameweek")
          : t("statusPanelTitleIn", "Top Transfers in this Gameweek")
      }
      url={`/statistics/${stat}`}
      onHeadingClick={handleTrackViewAllTopTransfers}
    >
      <Table className={fixedTable} aria-label={t("transfers", "Transfers")!}>
        <TableHeader>
          <Column className={elementDialogColumnStyles} isRowHeader>
            {t("player", "Player")}
          </Column>
          <Column className={transferIconColumnStyles}>&nbsp;</Column>
          <Column className={elementColumnStyles}>&nbsp;</Column>
          <Column className={transferredColumnStyles}>
            {t("transferred", "Transferred")}
          </Column>
        </TableHeader>
        <TableBody>
          {sortedElements.map((e) => (
            <TransfersTableRow
              key={e.id}
              element={e}
              team={teamsById[e.team]}
              stat={stat}
              icon={
                isOut ? (
                  <TransferredOutIcon className={styledTransferArrowIcon} />
                ) : (
                  <TransferredInIcon className={styledTransferArrowIcon} />
                )
              }
            />
          ))}
        </TableBody>
      </Table>
    </StatusPanel>
  );
};

export default TransfersTable;
